/**
 * LA RUEDA DEL RATON DEJA DE CAMBIAR LOS NUMEROS.
 *
 * Lissette, 2026-09-04: *"lo del mouse en los campos de numeros (premium, etc)
 * se sigue modificando con el scroll, me modifica, no me gusta, quitado"*.
 *
 * EL PROBLEMA, y no es de Deskte: es como se comporta `<input type="number">`
 * en TODOS los navegadores. Si el campo tiene el foco y ruedas la rueda encima,
 * el navegador sube o baja el numero en vez de mover la pagina. Quien acaba de
 * escribir una prima de $348.50, rueda para seguir bajando por el formulario y
 * se va con $349.50 guardado sin haber tecleado nada. No hay aviso, no hay
 * rastro: el numero simplemente es otro.
 *
 * LA SOLUCION: cuando se rueda encima de un campo de numero que tiene el foco,
 * se le QUITA el foco. A partir de ahi el navegador hace lo natural —mover la
 * pagina— y el numero se queda como estaba.
 *
 * POR QUE NO SE BLOQUEA EL EVENTO. `preventDefault()` habria impedido tambien
 * que la pagina se moviera con el raton encima del campo, y entonces el
 * formulario pareceria trabado. Perder el foco no molesta a nadie: quien rueda
 * es porque ya termino de escribir.
 *
 * POR QUE UN SOLO SITIO Y NO CAMPO POR CAMPO. Hay 66 campos de numero repartidos
 * entre `deskte-full.jsx` y los componentes, y manana habra mas. Un `onWheel` en
 * cada uno seria la garantia de que al siguiente se le olvida (regla de oro 118:
 * cuando una funcion tiene dos caminos, arreglar uno no es arreglarla). Se
 * escucha una vez, en captura, en todo el documento.
 *
 * Modulo sin React a proposito: se prueba con un documento de mentira.
 */

/**
 * Engancha el guardian. Devuelve la funcion para soltarlo (util en pruebas).
 *
 * @param {Document} doc
 */
export function evitarRuedaEnNumeros(doc) {
  const d = doc || (typeof document !== 'undefined' ? document : null);
  if (!d || typeof d.addEventListener !== 'function') return () => {};

  const alRodar = (e) => {
    const el = e && e.target;
    if (!el || el.tagName !== 'INPUT') return;
    // `type` en minusculas: el atributo puede venir escrito de cualquier forma.
    if (String(el.type || '').toLowerCase() !== 'number') return;
    // Solo si el campo TIENE el foco. Sin foco el navegador ya mueve la pagina
    // y no toca el numero, asi que quitarle el foco a otro elemento seria
    // robarselo por nada.
    if (d.activeElement !== el) return;
    if (typeof el.blur === 'function') el.blur();
  };

  // `capture` para llegar antes que cualquier manejador de la pantalla, y
  // `passive` porque no se cancela nada: solo se quita el foco.
  d.addEventListener('wheel', alRodar, { passive: true, capture: true });
  return () => d.removeEventListener('wheel', alRodar, { capture: true });
}
